<ion-content class="content-col">
  <ion-toolbar
    style="
      z-index: 999;
      position: sticky;
      top: 0;
      padding: 0 8px;
      border-bottom: 1px solid var(--ion-border-color);
    "
    [hidden]="!customerId"
  >
    <span
      class="tab-nav-link"
      *ngFor="let p of appPages; let i = index"
      routerDirection="root"
      [routerLink]="[p.url]"
      lines="none"
      detail="false"
      routerLinkActive="tab-nav-active"
      #rla="routerLinkActive"
    >
      <ion-icon
        slot="start"
        [name]="rla.isActive ? p.icon : p.icon + '-outline'"
      ></ion-icon>
      {{ p.title }}
    </span>
  </ion-toolbar>

  <ion-router-outlet id="customer-admin-content"></ion-router-outlet>
</ion-content>

<div class="left-col">
  <ion-card>
    <ion-card-title
      *ngIf="!customerId"
      style="display: flex; flex-direction: column"
    >
      <h1 style="margin: 0 8px">
        <ion-input
          [(ngModel)]="newCustomerName"
          class="input-field big-title-input"
          placeholder="Enter customer name"
          autocapitalize="sentences"
          style="font-size: 1.3rem; border: none"
          #newCustomerNameInput
        >
        </ion-input>
      </h1>

      <ion-button
        fill="clear"
        color="dark"
        (click)="selectProject()"
        class="button-dark-border"
        style="margin: 0 15px 15px 15px; width: 50%"
      >
        <ion-icon
          [name]="project?.name ? 'folder-open' : 'folder-open-outline'"
          class="padded-icon button-icon"
        ></ion-icon>
        {{
          project?.name ? project.name : project?.id ?? "Select a project..."
        }}
        <ion-icon
          name="chevron-down-outline"
          class="icon-padded-left button-icon"
        ></ion-icon>
      </ion-button>

      <ion-button
        (click)="createNewCustomer()"
        [disabled]="!newCustomerName || isSavingCustomFields"
        style="margin: 0 15px 15px 15px"
      >
        Save
        <ion-spinner
          name="crescent"
          *ngIf="isSavingCustomFields"
          style="margin-left: 5px"
        ></ion-spinner>
      </ion-button>
    </ion-card-title>
    <ion-list *ngIf="customerId && !customer" lines="none">
      <ion-list-header>
        <ion-skeleton-text
          [animated]="true"
          style="width: 80px"
        ></ion-skeleton-text>
      </ion-list-header>
      <ion-item>
        <ion-skeleton-text
          [animated]="true"
          style="width: 40%"
        ></ion-skeleton-text>
        <ion-label>
          <h3>
            <ion-skeleton-text
              [animated]="true"
              style="width: 60%"
            ></ion-skeleton-text>
          </h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-skeleton-text
          [animated]="true"
          style="width: 30%"
        ></ion-skeleton-text>
        <ion-label>
          <h3>
            <ion-skeleton-text
              [animated]="true"
              style="width: 70%"
            ></ion-skeleton-text>
          </h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-skeleton-text
          [animated]="true"
          style="width: 20%"
        ></ion-skeleton-text>
        <ion-label>
          <h3>
            <ion-skeleton-text
              [animated]="true"
              style="width: 80%"
            ></ion-skeleton-text>
          </h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-skeleton-text
          [animated]="true"
          style="width: 25%"
        ></ion-skeleton-text>

        <ion-label>
          <h3>
            <ion-skeleton-text
              [animated]="true"
              style="width: 75%"
            ></ion-skeleton-text>
          </h3>
        </ion-label>
      </ion-item>
    </ion-list>
    <div *ngIf="customer">
      <div
        class="header"
        *ngIf="customer.slackTeams?.length >= 1 && customer.slackTeams[0]?.icon"
      >
        <img src="{{ customer.slackTeams[0]?.icon }}" class="header-blur" />
      </div>
      <img
        src="{{ customer.slackTeams[0]?.icon }}"
        class="header-image"
        *ngIf="customer.slackTeams?.length >= 1 && customer.slackTeams[0]?.icon"
      />
      <ion-card-title>
        <h1 style="margin: 0 8px">
          <ion-input
            *ngIf="customer.name !== null && customer.name !== undefined"
            #customerNameInput
            [(ngModel)]="customer.name"
            class="input-field big-title-input"
            placeholder="Customer name"
            autocapitalize="sentences"
            (ionBlur)="saveEditedName()"
            style="font-size: 1.3rem; border: none"
          >
          </ion-input>
          <ion-input
            *ngIf="customer.name === null || customer.name === undefined"
            value="{{ PRIVATE_CHANNEL_NAME }}"
            class="input-field big-title-input"
            style="font-size: 1.3rem; border: none"
            disabled
          >
          </ion-input>
        </h1>
      </ion-card-title>
      <div class="hidden-vertical">
        <ion-button
          color="light"
          shape="round"
          class="btn-small circle-button"
          style="margin-left: 12px"
          (click)="viewInbox()"
          ngxTippy
          data-tippy-content="View in inbox"
          [tippyProps]="{
            placement: 'bottom'
          }"
        >
          <ion-icon name="file-tray"></ion-icon>
        </ion-button>
        <ion-button
          color="light"
          shape="round"
          class="btn-small circle-button"
          (click)="composeSlackBroadcast()"
          ngxTippy
          data-tippy-content="Compose broadcast"
          [tippyProps]="{
            placement: 'bottom'
          }"
        >
          <ion-icon name="send"></ion-icon>
        </ion-button>
        <ion-button
          color="light"
          shape="round"
          class="btn-small circle-button"
          (click)="openSlackChannel()"
          *ngIf="customer.slackChannel"
          ngxTippy
          data-tippy-content="Open channel in Slack"
          [tippyProps]="{
            placement: 'bottom'
          }"
        >
          <ion-icon name="logo-slack"></ion-icon>
        </ion-button>
        <ion-button
          color="light"
          shape="round"
          class="btn-small circle-button"
          (click)="showOptions()"
          ngxTippy
          data-tippy-content="More options"
          [tippyProps]="{
            placement: 'bottom'
          }"
        >
          <ion-icon name="ellipsis-vertical"></ion-icon>
        </ion-button>
      </div>
      <ion-list class="hidden-vertical" lines="none" style="padding-bottom: 0">
        <ion-item>
          <ion-label>
            <p>Channel</p>
          </ion-label>
          <ion-label
            *ngIf="customer.slackChannel"
            (click)="openSlackChannel()"
            class="clickable"
            slot="end"
          >
            <ion-icon name="logo-slack"></ion-icon>
            {{ customer.slackChannel.name ?? PRIVATE_CHANNEL_NAME }}
          </ion-label>
          <ion-label *ngIf="!customer.slackChannel" slot="end">None</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>
            <p>Type</p>
          </ion-label>
          <ion-label slot="end">
            <ion-icon
              [name]="customer.isInternal ? 'people' : 'business'"
            ></ion-icon>
            {{
              customer.isInternal
                ? "Internal channel"
                : "Shared customer channel"
            }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>
            <p>Created</p>
          </ion-label>
          <ion-label slot="end">
            {{ customer.createdAt | date: "MMM d yyyy" }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>
            <p>Project</p>
          </ion-label>
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            (click)="selectProject()"
          >
            <ion-label>
              <ion-icon
                *ngIf="
                  customer.project?.visibility === PROJECT_VISIBILITY.RESTRICTED
                "
                name="lock-closed"
              ></ion-icon>
              {{ customer.project?.name }}
              <ion-icon
                name="chevron-down-outline"
                class="icon-padded-left button-icon"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </ion-item>

        <div *ngIf="customer">
          <ion-item>
            <ion-label>
              <p>Primary rep</p>
            </ion-label>

            <ion-chip
              mode="ios"
              class="select-chip select-outline"
              [outline]="true"
              (click)="showAssigneeOptions(true)"
            >
              <ion-label>
                {{ primarySupportAssigneeName }}
                <ion-icon
                  name="chevron-down-outline"
                  class="icon-padded-left button-icon"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </ion-item>

          <ion-item>
            <ion-label>
              <p>Secondary rep</p>
            </ion-label>
            <ion-chip
              mode="ios"
              class="select-chip select-outline"
              [outline]="true"
              (click)="showAssigneeOptions(false)"
            >
              <ion-label>
                {{ secondarySupportAssigneeName }}
                <ion-icon
                  name="chevron-down-outline"
                  class="icon-padded-left button-icon"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </ion-item>
          <ion-item *ngIf="authService.tenant?.externalCrmConfig?.enabled">
            <ion-label
              ><p>{{ this.authService.tenant.externalCrmConfig.name }}</p>
            </ion-label>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <a
                [href]="customer?.externalCrmMetadata.url"
                target="_blank"
                *ngIf="customer?.externalCrmMetadata?.id"
              >
                <ion-icon name="open"></ion-icon>
                Open profile in {{ connectedCrm }}
              </a>
              <a (click)="linkCrm()" *ngIf="!customer?.externalCrmMetadata?.id">
                <ion-icon name="unlink-outline"></ion-icon>
                Connect
              </a>
              <ion-button
                class="btn-small"
                color="dark"
                fill="clear"
                (click)="unlinkCrm()"
                *ngIf="customer?.externalCrmMetadata?.id"
              >
                <ion-icon name="close-outline"></ion-icon>
              </ion-button>
            </div>
          </ion-item>
        </div>
      </ion-list>
      <div class="hidden-vertical" *ngIf="customer">
        <app-response-input
          *ngIf="customFieldValues"
          [responseInputFields]="customFieldValues"
          [showPublicOption]="false"
          (didChange)="didUpdateCustomFields()"
          layout="list"
        >
        </app-response-input>
        <div class="flex-space-between">
          <ion-button
            fill="clear"
            color="dark"
            class="btn-small"
            (click)="manageCustomFields()"
            *ngIf="authService.isTenantAdmin"
          >
            <ion-icon name="add-outline" class="padded-icon"></ion-icon>
            Manage custom fields
          </ion-button>
        </div>
      </div>
      <ion-button
        size="block"
        color="dark"
        *ngIf="customer.type === CHANNEL_TYPES.EMAIL"
        (click)="editEmailConfiguration()"
      >
        <ion-icon name="mail" class="icon-padded"></ion-icon>
        Edit email configuration
      </ion-button>
      <ion-button
        size="block"
        color="dark"
        *ngIf="customer.type === CHANNEL_TYPES.WIDGET"
        (click)="editInAppChatConfiguration()"
      >
        <ion-icon name="chatbubble" class="icon-padded"></ion-icon>
        Edit in-app chat configuration
      </ion-button>
      <ion-button
        size="block"
        color="dark"
        *ngIf="customer.type === CHANNEL_TYPES.MICROSOFT_TEAMS"
        (click)="editMicrosoftTeamsConfiguration()"
      >
        <ion-icon name="custom-teams" class="icon-padded"></ion-icon>
        Edit Microsoft Teams configuration
      </ion-button>
    </div>
  </ion-card>

  <ion-card class="hidden-vertical" *ngIf="customer" style="margin-top: 25px">
    <ion-card-content>
      <ion-card-subtitle> Tags </ion-card-subtitle>
    </ion-card-content>
    <ion-button
      class="btn-small"
      shape="round"
      color="light"
      *ngFor="let tag of customer.tags"
      (click)="editTag(tag)"
    >
      <ion-icon
        name="pricetags"
        style="margin-right: 4px; font-size: 0.75rem"
      ></ion-icon>
      {{ tag.name }}
    </ion-button>
    <ion-button fill="clear" color="dark" class="btn-small" (click)="addTag()">
      <ion-icon name="add-outline" class="icon-padded"></ion-icon>
      Add tag
    </ion-button>
  </ion-card>

  <ion-card class="hidden-vertical" *ngIf="customer" style="margin-top: 25px">
    <ion-card-content>
      <ion-card-subtitle> Admins </ion-card-subtitle>
    </ion-card-content>
    <ion-list class="no-padding">
      <ion-item *ngFor="let admin of customer.adminEmails; let i = index">
        <ion-label> {{ admin }} </ion-label>
        <ion-button
          fill="clear"
          slot="end"
          color="dark"
          ngxTippy
          data-tippy-content="Remove admin"
          (click)="deleteAdminEmailAtIndex(i)"
        >
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-item>
    </ion-list>
    <ion-button
      fill="clear"
      color="dark"
      class="btn-small"
      (click)="addAdmin()"
    >
      <ion-icon name="add-outline" class="icon-padded"></ion-icon>
      Add admin
    </ion-button>
  </ion-card>
</div>

<ion-modal
  [isOpen]="isShowingCustomFieldsModal"
  (willDismiss)="onDismissCustomFieldsModal()"
>
  <ng-template>
    <ion-header>
      <ion-toolbar class="modal-header">
        <div class="modal-title">
          <h3>Manage Custom Attributes</h3>
        </div>
        <ion-buttons slot="end">
          <ion-button
            fill="clear"
            shape="round"
            class="close-button"
            (click)="onDismissCustomFieldsModal()"
          >
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <app-custom-fields
        placeholder="Ex: Plan type"
        [customFields]="customFieldOptions"
        [addCustomFieldButtonLabel]="'Add a custom customer attribute'"
        [showPublicOption]="true"
        [showUserAttributeOption]="false"
      >
      </app-custom-fields>
      <ion-button
        (click)="updateDefaultCustomFields()"
        [disabled]="isSavingCustomFields"
        style="margin: 10px"
      >
        Save
        <ion-spinner
          name="crescent"
          style="margin-left: 6px"
          *ngIf="isSavingCustomFields"
        ></ion-spinner>
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
